module.exports = __webpack_public_path__ + "img/proses-negosiasi-active.d1176316.svg";